import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../AuthContext';
import { api } from '../api';

const DynamicAmenityDropdown = ({ 
  value, 
  onChange, 
  required = false, 
  className = "",
  onAmenitySelect = null 
}) => {
  const { user } = useContext(AuthContext);
  const [amenityTypes, setAmenityTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user?.hoa_id) {
      loadAmenityTypes();
    }
  }, [user?.hoa_id]);

  const loadAmenityTypes = async () => {
    setLoading(true);
    try {
      const response = await api.get('/api/amenities/types', {
        params: { hoa_id: user.hoa_id }
      });
      
      if (response.data.success) {
        const activeTypes = (response.data.amenity_types || []).filter(type => type.is_active);
        setAmenityTypes(activeTypes);
      }
    } catch (error) {
      console.error('Failed to load amenity types:', error);
      // Fallback to setup default amenities if none exist
      try {
        await api.post(`/api/amenities/setup/${user.hoa_id}`);
        // Retry loading after setup
        const retryResponse = await api.get('/api/amenities/types', {
          params: { hoa_id: user.hoa_id }
        });
        if (retryResponse.data.success) {
          const activeTypes = (retryResponse.data.amenity_types || []).filter(type => type.is_active);
          setAmenityTypes(activeTypes);
        }
      } catch (setupError) {
        console.error('Failed to setup amenity types:', setupError);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const selectedValue = e.target.value;
    onChange(selectedValue);
    
    // If callback provided, send selected amenity details
    if (onAmenitySelect && selectedValue) {
      const selectedAmenity = amenityTypes.find(type => type.name === selectedValue);
      onAmenitySelect(selectedAmenity);
    }
  };

  if (loading) {
    return (
      <select 
        disabled 
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
      >
        <option>Loading amenities...</option>
      </select>
    );
  }

  return (
    <select
      required={required}
      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
      value={value}
      onChange={handleChange}
    >
      <option value="">Select Amenity</option>
      {amenityTypes.map(amenity => (
        <option key={amenity.id} value={amenity.name}>
          {amenity.name}
          {amenity.capacity > 1 && ` (Capacity: ${amenity.capacity})`}
        </option>
      ))}
    </select>
  );
};

export default DynamicAmenityDropdown;